<template>
  <div class="breadcrumb">
    <div class="left">
      <svg-icon icon-class="home" class="icon" @click.native="handleHome" />
      <el-breadcrumb class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="item in levelList" :key="item.path">
            <span class="no-redirect">{{ item.meta.title }}</span>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb>
    </div>
    <div v-if="$route.meta.back" class="back" @click="handleBack">
      <svg-icon icon-class="back" />
      返回
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      this.levelList = null;
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      const first = matched[0];
      //console.info(matched);
      if (this.isDashboard(first)) {
        this.levelList = null;
      }
      let lastMatched = matched[matched.length - 1];
      if (this.levelList && this.levelList.length > 1 && lastMatched.parent) {
        if (this.levelList.find((s) => s.path === lastMatched.path)) {
          let targetIndex = this.levelList.findIndex(
            (s) => s.path === lastMatched.path
          );
          this.levelList = this.levelList.splice(0, targetIndex + 1);
        } else {
          this.levelList.push(lastMatched);
        }
      } else {
        this.levelList = matched.filter(
          (item) =>
            item.meta && item.meta.title && item.meta.breadcrumb !== false
        );
      }
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return (
        name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
      );
    },
    handleHome() {
      if(this.isDashboard(this.$route)) {
        return
      }
      this.$router.push({
        name: 'Dashboard'
      })
    },
    handleBack() {
      this.$router.back()
    }
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  justify-content: space-between;
  margin: 14px 16px;
}
.left {
  display: flex;
}
.icon {
  font-size: 16px;
  margin-right: 2px;
  margin-top: 6px;
  cursor: pointer;
}
.back {
  font-size: 14px;
  line-height: 20px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 4px 8px;
  color: #3A6FD6;
  cursor: pointer;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  margin-left: 8px;
  margin-top: 4px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
